/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { useSelector } from "react-redux"
import { SingleCategoryReimbursementsList } from "./company-plan-config-type/SingleCategoryList"
import { MultipleCategoriesReimbursementsLists } from "./company-plan-config-type/MultipleCategoriesReimbursementsLists"
import { getSubsidies } from "#/redux/reducers/subsidies"
import { useReimbursements } from "#/services/user/hooks/useReimbursements"
import { BenefitType, Subsidy } from "#/lib/carrot-api/types/Subsidy"
import { countCategories, getCategoryGroups, isCreditMember } from "../../molecules/subsidyCategoryGroups"

interface ReimbursementsListProps {
  onTransactionClick?: (transaction: any) => void
}

const ReimbursementsList: React.FC<ReimbursementsListProps> = ({ onTransactionClick }) => {
  const { data: reimbursementsList } = useReimbursements()

  const subsidies: Subsidy[] = useSelector(getSubsidies)
  const creditMember = !!subsidies && isCreditMember(subsidies)
  const creditCategoryGroups = creditMember ? getCategoryGroups(subsidies) : null
  const hasMultipleCategories = !!subsidies && countCategories(subsidies) > 1
  const creditGroup = creditCategoryGroups?.[0]
  const creditSubsidy = creditGroup?.find((subsidy) => subsidy.benefitType === BenefitType.CREDIT)
  const singleSubsidy =
    creditGroup?.find((subsidy) => subsidy.benefitType !== BenefitType.CREDIT) ?? creditGroup?.[0] ?? subsidies?.[0]
  // No usable category: keep expense history, but don't show a balance from a filtered-out plan.
  const hideBalance = creditMember && creditCategoryGroups.length === 0

  return (
    <div>
      {subsidies &&
        reimbursementsList &&
        (hasMultipleCategories ? (
          <MultipleCategoriesReimbursementsLists
            reimbursementsList={reimbursementsList}
            subsidies={subsidies}
            onTransactionClick={onTransactionClick}
          />
        ) : (
          <SingleCategoryReimbursementsList
            reimbursementsList={reimbursementsList}
            subsidy={singleSubsidy}
            creditSubsidy={creditSubsidy}
            hideBalance={hideBalance}
            onTransactionClick={onTransactionClick}
          />
        ))}
    </div>
  )
}

export default ReimbursementsList
